export default __webpack_public_path__ + "static/media/pageNotFound.fbaa7809.jpg";